export function formatCentAmount(value: number | null, currencyCode: string | null): string {
  if (value === null || !currencyCode) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatWholeAmount(value: number | null, currencyCode: string | null): string {
  if (value === null || !currencyCode) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.round(value));
}
